import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';

export class ChannelClusterDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.CHANNELCLUSTER, apiHelper);
  }

  getAllChannelClusters(): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, 'GET', null, null, headers, null);
  }
  createChannelCluster(data): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, 'POST', null, data, headers, null);
  }
}
